import { useEffect, useRef } from "react";
import { loadFromURL } from "@/lib/fileLoader";
import { saveSession, loadSession } from "@/lib/persist";
import { logWarn } from "@/lib/log";

// Restore per-user session once, then persist analyzer state on change
export function useSessionPersistence(userId, state, restore) {
  const restoredRef = useRef(false);
  const restoreRef = useRef(restore);
  restoreRef.current = restore;

  useEffect(() => {
    const s = loadSession(userId);
    if (s) {
      restoreRef.current(s);
      if (s.imageURL) {
        loadFromURL(s.imageURL)
          .then((loaded) => restoreRef.current({ loadedImage: loaded }))
          .catch((e) => logWarn("Could not restore session image", e));
      }
    }
    // Allow persistence after this tick so restored state isn't overwritten
    const t = setTimeout(() => { restoredRef.current = true; }, 0);
    return () => clearTimeout(t);
  }, [userId]);

  const { polygon, rotation, sectorCount, markers, imageURL } = state;
  useEffect(() => {
    if (!restoredRef.current) return;
    saveSession(userId, { polygon, rotation, sectorCount, markers, imageURL });
  }, [userId, polygon, rotation, sectorCount, markers, imageURL]);
}
